import * as FlatModels from '@medsurf/flat-models';
import type { Params } from '@angular/router';

// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetTrainingNodesByCurrentSubject = '[STORE | SHARED | TRAINING] Get Training Nodes By Current Subject',
  GetTrainingNodesBySelectedSlides = '[STORE | SHARED | TRAINING] Get Training Nodes By Selected Slides',
  GetSlideEntitySuccess = '[STORE | SHARED | TRAINING] Get Slide Entity Success',
  GetSlideEntitiesSuccess = '[STORE | SHARED | TRAINING] Get Slide Entities Success',
  GetBlockEntitySuccess = '[STORE | SHARED | TRAINING] Get Block Entity Success',
  GetBlockEntitiesSuccess = '[STORE | SHARED | TRAINING] Get Block Entities Success',
  ToggleTrainingSelection = '[STORE | SHARED | TRAINING] Toggle Training Selection',
  SetupQuestionChoicesOrder = '[STORE | SHARED | TRAINING] Setup Question Choices Order',
  Reset = '[STORE | SHARED | TRAINING] Reset',
  SetupTraining = '[STORE | SHARED | TRAINING] Setup Training',
  SetupCase = '[STORE | SHARED | TRAINING] Setup Case',
  Start = '[STORE | SHARED | TRAINING] Start',
  UpdateSlideResult = '[STORE | SHARED | TRAINING] Update Slide Result',
  SetShowFeedback = '[STORE | SHARED | TRAINING] Set Show Feedback',
  ToggleShowExplanation = '[STORE | SHARED | TRAINING] Toggle Show Explanation',
  GoToStart = '[STORE | SHARED | TRAINING] Go To Start',
  GoToSlideByNode = '[STORE | SHARED | TRAINING] Go To Slide By Node',
  TrackQuizAnswer = '[STORE | SHARED | TRAINING] Track Quiz Answer',
  /**
   * Request
   */
  GetTrainingNodesBySubjectIdRequest = '[REQUEST | SHARED | TRAINING] Get Training Nodes By SubjectId Request',
  GetTrainingNodesByIdsRequest = '[REQUEST | SHARED | TRAINING] Get Training Nodes By Ids Request',
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Training Nodes By Current Subject
 */
export class GetTrainingNodesByCurrentSubject {
  public static readonly type = ActionTypes.GetTrainingNodesByCurrentSubject;
}

/**
 * Get Training Nodes By Selected Slides
 */
export class GetTrainingNodesBySelectedSlides {
  public static readonly type = ActionTypes.GetTrainingNodesBySelectedSlides;
}

/**
 * Get Slide Entity Success
 */
export class GetSlideEntitySuccess {
  public static readonly type = ActionTypes.GetSlideEntitySuccess;

  public constructor(public entityQueryResult: FlatModels.TrainingSharedModels.TrainingSharedSlideQueryResult) {
  }
}

/**
 * Get Slide Entities Success
 */
export class GetSlideEntitiesSuccess {
  public static readonly type = ActionTypes.GetSlideEntitiesSuccess;

  public constructor(public entityQueryResults: FlatModels.TrainingSharedModels.TrainingSharedSlideQueryResult[]) {
  }
}

/**
 * Get Block Entity Success
 */
export class GetBlockEntitySuccess {
  public static readonly type = ActionTypes.GetBlockEntitySuccess;

  public constructor(public entityQueryResult: FlatModels.TrainingSharedModels.TrainingSharedBlockQueryResult) {
  }
}

/**
 * Get Block Entities Success
 */
export class GetBlockEntitiesSuccess {
  public static readonly type = ActionTypes.GetBlockEntitiesSuccess;

  public constructor(public entityQueryResults: FlatModels.TrainingSharedModels.TrainingSharedBlockQueryResult[]) {
  }
}

/**
 * Toggle Training Selection
 */
export class ToggleTrainingSelection {
  public static readonly type = ActionTypes.ToggleTrainingSelection;

  public constructor(public slides: string[],
                     public override: boolean) {
  }
}

/**
 * Setup Question Choices Order
 */
export class SetupQuestionChoicesOrder {
  public static readonly type = ActionTypes.SetupQuestionChoicesOrder;

  public constructor(public question: FlatModels.QuestionEntityModels.QuestionEntityType) {
  }
}

/**
 * Reset
 */
export class Reset {
  public static readonly type = ActionTypes.Reset;
}

/**
 * Setup Training
 */
export class SetupTraining {
  public static readonly type = ActionTypes.SetupTraining;
}

/**
 * Setup Case
 */
export class SetupCase {
  public static readonly type = ActionTypes.SetupCase;
}

/**
 * Start
 */
export class Start {
  public static readonly type = ActionTypes.Start;
}

/**
 * Update Slide Result
 */
export class UpdateSlideResult {
  public static readonly type = ActionTypes.UpdateSlideResult;

  public constructor(public slideResult: FlatModels.TrainingSharedModels.TrainingResultType) {
  }
}

/**
 * Set Show Feedback
 */
export class SetShowFeedback {
  public static readonly type = ActionTypes.SetShowFeedback;

  public constructor(public slideResult: FlatModels.TrainingSharedModels.TrainingResultType,
                     public question: FlatModels.QuestionEntityModels.QuestionEntityType) {
  }
}

/**
 * Toggle Show Explanation
 */
export class ToggleShowExplanation {
  public static readonly type = ActionTypes.ToggleShowExplanation;

  public constructor(public slideResult: FlatModels.TrainingSharedModels.TrainingResultType) {
  }
}

/**
 * Go To Start
 */
export class GoToStart {
  public static readonly type = ActionTypes.GoToStart;
}

/**
 * Go To Slide By Node
 */
export class GoToSlideByNode {
  public static readonly type = ActionTypes.GoToSlideByNode;

  public constructor(public slideNode: FlatModels.NodeEntityModels.SlideNode,
                     public queryParams: Params) {
  }
}

/**
 * Track Quiz Answer
 */
export class TrackQuizAnswer {
  public static readonly type = ActionTypes.TrackQuizAnswer;

  public constructor(public slideId: string,
                     public question: FlatModels.QuestionEntityModels.QuestionEntityType,
                     public isCorrect: boolean) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Get Training Nodes By SubjectId Request
 */
export class GetTrainingNodesBySubjectIdRequest {
  public static readonly type = ActionTypes.GetTrainingNodesBySubjectIdRequest;

  public constructor(public id: string) {
  }
}

/**
 * Get Training Nodes By Ids Request
 */
export class GetTrainingNodesByIdsRequest {
  public static readonly type = ActionTypes.GetTrainingNodesByIdsRequest;

  public constructor(public ids: string[]) {
  }
}

// </editor-fold>
